const sliders = document.querySelectorAll('.card__slider');

sliders.forEach(slider => {
  const container = slider.querySelector('.card__slider-container');
  const slides = slider.querySelectorAll('.card__slide');
  const thumbnails = slider.querySelectorAll('.slider__thumbnail');

  const prev = slider.querySelector('.slider__control--prev');
  const next = slider.querySelector('.slider__control--next');

  let index = 0;

  render();

  const render = () => {
     container.style.transform = `translate(${-100 * index}%, 0%)`;

    thumbnails.forEach(thumbnail => {
      thumbnail.classList.remove('slider__thumbnail--active');
    });

    thumbnails[index].classList.add('slider__thumbnail--active');
  };

  prev.addEventListener('click', () => {
    index -= 1;

    if (index < 0) {
      index = slides.length - 1;
    }

    render();
  });

  next.addEventListener('click', () => {
    index += 1;

    if (index > slides.length - 1) {
      index = 0;
    }

    render();
  });

  thumbnails.forEach((thumbnail) => {
    thumbnail.addEventListener('click', () => {
      index = parseInt(thumbnail.getAttribute('data-index'));
      render();
    });
  });
});
